import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../../global.service';
@Component({
  selector: 'app-iptv-questions',
  templateUrl: './iptv-questions.component.html',
  styleUrls: ['./iptv-questions.component.sass']
})
export class IptvQuestionsComponent implements OnInit {
  public tabActive = 'Mis Equipos y Servicios';
  public currentList;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public totalAccountList;
  public selectBan;
  public token: string = sessionStorage.getItem("token");
  public content: object;
  constructor(public global: GlobalService) { }

  ngOnInit() {
    this.content = {
      content: [
        {
          title: "¿Qué es Claro tv+?",
          description: "Es televisión que se mueve contigo. Esta aplicación que te trae Claro te permite ver contenido de TV en vivo desde tu casa o en tus dispositivos y mientras estés conectado al internet fijo de Claro, desde cualquier lugar en Puerto Rico. Disfruta de: contenido en vivo de tus canales favoritos, contenido On Demand transaccional de películas de estrenos y contenido gratuito para el disfrute de toda la familia. En adición, Claro tv+ te ofrece servicios adicionales tales como: Cloud DVR para grabar en la nube y TV a tu tiempo que te permite retroceder tu programación hasta 7 días. Suscríbete a nuestro servicio de Claro tv+ con Internet, descarga la aplicación, configura tu usuario y contraseña y comienza a disfrutar de tu plan de entretenimiento. Requiere un mínimo de 5 megas.",
          expand: true
        },
        {
          title: "¿En qué dispositivos puedo ver Claro tv+?",
          description: "Claro tv+ puede ser disfrutado utilizando tu Claro tv+ Home Box, a través de dispositivos con acceso a las plataformas Android, y Android TV, IOS y TVOS, Amazon Firesticks y a través del webclient disponible para sistemas Windows y Mac.",
          expand: false
        },
        {
          title: "¿En qué red puedo ver Claro tv+?",
          description: "En la red fija de internet de Claro PR.",
          expand: false
        },
        {
          title: "¿Cuantos equipos puedo registrar en mi cuenta?",
          description: "Depende del tipo de cuenta que tenga el cliente.",
          expand: false
        },
        {
          title: "¿Cuantos equipos puedo utilizar simultaneamente?",
          description: "El cliente puede tener hasta 10 dispositivos por cuenta y podrá utilizar hasta 3 de manera simultánea.",
          expand: false
        },
        {
          title: "¿Qué dispositivos estarán disponibles en el futuro?",
          description: "Estamos trabajando para también tener disponible el app de Claro tv+ en dispositivos Samsung TV, LG, y Roku.",
          expand: false
        },
        {
          title: "¿Qué necesito para tener Claro tv+?",
          description: "Para poder disfrutar de Claro tv+ debes tener una suscripción a un plan de televisión de Claro tv+ con el dispositivo streaming. Internet de Claro de 5Mbps o más. Un dispositivo compatible con el app de Claro tv+ descargada y tus credenciales de Claro tv+ para acceder la aplicación.",
          expand: false
        },
        {
          title: "¿Cómo obtengo la aplicación de Claro tv+?",
          description: "La aplicación va a estar disponible en los Apps Store del dispositivo compatible.",
          expand: false
        },
        {
          title: "¿Cómo manejo mi cuenta Claro tv+?",
          description: "Cliente debe crear un usuario y contraseña, en la página web asignada a Claro tv+, debe ingresar el email brindado al momento de la venta.",
          expand: false
        },
        {
          title: "¿Quien es la persona autorizada para manejar mi cuenta?",
          description: "Solo el dueño de la cuenta está autorizado a manejar la cuenta, a menos que autorice otra persona en la cuenta con el personal de Claro. Tu eres responsable de tus credenciales. En caso de que necesites asistencia adicional con el servicio de Claro tv+ siempre puedes contactar a Servicio y/o Apoyo Técnico al 787-775-0000.",
          expand: false
        },
        {
          title: "Equipo - SEI 810 CPR",
          image: [
            {
              url: "/assets/images/questions/STB_img_02.png"
            },
            {
              url: "/assets/images/questions/STB_img_04.png"
            },
            {
              url: "/assets/images/questions/STB_img_06.png"
            },
            {
              url: "/assets/images/questions/STB_img_07.png"
            },
            {
              url: "/assets/images/questions/STB_img_08.png"
            }
          ],
          expand: false
        },
        {
          title: "Control Remoto - SEI 810 CPR",
          image: [
            {
              url: "/assets/images/questions/CPR_Remote_Control.png"
            }
          ],
          expand: false
        }
      ]
    };

  }
  initializeData() {
    this.global.refreshDataTo(this.token);
  }
}

